import styled from 'styled-components';
export var InsetLink = styled.a.withConfig({
  componentId: "sc-rvlk6i-0"
})(["position:absolute;inset:0;"]);